<template>
  <div class="form-group mt-5" :class="{ hasValue: showInput }">
    <div :class="{ invalid: isInvalid() }">
      <input
        ref="item"
        :type="config.InputType"
        :name="'text' + id"
        :data-vv-as="config.ErrorMessage"
        v-validate="config.Validation"
        :id="'input' + id"
        class="form-control"
        :value="value"
        :required="config.Validation.required"
        @input="update()"
        @change="doChange()"
        @blur="update()"
      />
    </div>
    <label class="form-control-placeholder" :for="'input' + id">
      <span>{{ config.Placeholder }}</span>
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
    </label>
    <div class="invalid-mandatory" ref="error" v-if="isInvalid()">
      {{ errors.first('text' + id) }}
    </div>
  </div>
</template>

<script>
  import PhoneNumber from 'awesome-phonenumber';
  export default {
    inject: {
      $validator: '$validator',
    },
    props: ['value', 'id', 'config'],
    data() {
      return {
        showInput: false,
      };
    },
    methods: {
      update() {
        if (this.value || this.$refs.item.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }

        if (
          this.$refs.item.value.indexOf('+') < 0 &&
          this.$refs.item.value !== '+45 ' &&
          this.$refs.item.value.length > 0
        ) {
          this.$emit('input', '+45 ' + this.$refs.item.value);
        } else {
          this.$emit('input', this.$refs.item.value);
        }
      },
      doChange() {
        this.$emit('getNewData');
        let phone = new PhoneNumber(this.$refs.item.value);
        let newPh = this.$refs.item.value.replace(/\s+/g, '');
        newPh = newPh.replace(
          phone.getCountryCode(),
          phone.getCountryCode() + ' '
        );
        this.$emit('input', newPh);
      },
      isInvalid() {
        if (
          this.errors.first('text' + this.id) &&
          this.$store.state.componentIsInvalid
        ) {
          return true;
        }
        return (
          this.$store.state.componentIsInvalid &&
          this.value == '' &&
          this.config.Validation.required &&
          this.errors.first('text' + this.id)
        );
      },
    },
    mounted() {
      if (this.value) {
        this.showInput = true;
      } else {
        this.showInput = false;
      }
    },
    created() {
      this.$validator.extend('phoneNumber', {
        validate(value) {
          return new Promise((resolve) => {
            let phone = new PhoneNumber(value);
            let error = false;
            if (value.indexOf('+') >= 0 && value.length === 8) {
              error = false;
            } else if (value.length === 8 && value > 0) {
              error = true;
            }
            resolve({ valid: phone.isValid() || error });
          });
        },
      });
    },
  };
</script>
<style lang="scss" scoped>
  .invalid-feedback {
    display: block;
  }
</style>
